import styled from "styled-components";
import { Colors } from "../../../shared/colors/colors";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 8px 60px;
  gap: 16px;
  width: 90vw;
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: bold;
  color: ${Colors.label};
`;

export const ContainerFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

export const ContainerButtons = styled.div`
  /* margin-bottom: 16px; */
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TitleContainer = styled.div`
  margin-bottom: 8px;
`;

export const InputContainer = styled.div`
  margin-bottom: 16px;
`;
